import React from "react";
import "../../../../../app/tileable/instructions/component/Instructions.scss";

export class InPayInstructions extends React.Component {

    render() {
        return (
            <h1>Processing your <br/>
                <span className="white-text">payment...</span>
            </h1>
        );
    }

}

